import { Apple, BriefcaseBusiness, Heart, type LucideIcon, Users } from 'lucide-react';
import { BAROMETER_AREAS } from 'constants/surveys';
import type { BarometerSpecificAreaKey } from 'types/surveys';

export const AREA_LUCIDE_ICONS: Record<BarometerSpecificAreaKey, LucideIcon> = {
  [BAROMETER_AREAS.EMOTIONAL]: Heart,
  [BAROMETER_AREAS.RELATIONAL]: Users,
  [BAROMETER_AREAS.PROFESSIONAL]: BriefcaseBusiness,
  [BAROMETER_AREAS.HEALTH]: Apple,
};

export interface WellBeingAreaProps {
  area: BarometerSpecificAreaKey;
  score?: number;
  maxScore?: number;
  showScore?: boolean;
  className?: string;
}
